import styled from "styled-components";

import {
  BoxContent as BoxContentBase,
  CautionBox as CautionBoxBase,
  CardButtons as CardButtonsBase,
} from "../ModalWelcome/styles";

export const BoxContent = styled(BoxContentBase)`
  h4 {
    /* O botão "Fechar" fica no canto superior direito da WhiteBox: em telas
       estreitas o título quebra em duas linhas e passaria por baixo dele. */
    padding-right: 6.5rem;
    margin-bottom: 1rem;
  }
`;

export const CautionBox = styled(CautionBoxBase)`
  margin-bottom: 0;
`;

// O bloco de botões do ModalWelcome carrega 48px de padding e mais 2rem da
// classe marginButton, pensados para telas com muito conteúdo. Aqui isso
// deixava um vão enorme entre a caixa de aviso e o botão.
export const CardButtons = styled(CardButtonsBase)`
  padding-top: 2rem;
  margin-top: 0;
`;
